function getRelativeOffsetValue(_ref) {
  var targetOffset = _ref.targetOffset,
    targetType = _ref.targetType,
    isTargetDueDate = _ref.isTargetDueDate;
  var relativeTarget = {
    due: {
      creation: {
        days: 'nudge_remind_panel_count_days_after_account_creation_due',
        weeks: 'nudge_remind_panel_count_weeks_after_account_creation_due'
      },
      audience: {
        days: 'nudge_remind_panel_count_days_after_joining_audience_due',
        weeks: 'nudge_remind_panel_count_weeks_after_joining_audience_due'
      }
    },
    target: {
      creation: {
        days: 'nudge_remind_panel_count_days_after_account_creation_target',
        weeks: 'nudge_remind_panel_count_weeks_after_account_creation_target'
      },
      audience: {
        days: 'nudge_remind_panel_count_days_after_joining_audience_target',
        weeks: 'nudge_remind_panel_count_weeks_after_joining_audience_target'
      }
    }
  };
  if (targetOffset && targetType) {
    var offsetTimeValue = targetOffset % 7 === 0 ? 'weeks' : 'days';
    var targetOffsetKey = isTargetDueDate ? 'due' : 'target';
    var count = offsetTimeValue === 'weeks' ? targetOffset / 7 : targetOffset;
    var relativeTargetOffset = relativeTarget[targetOffsetKey][targetType][offsetTimeValue];
    return {
      relativeTargetOffset: relativeTargetOffset,
      count: count
    };
  }
  return undefined;
}
export default getRelativeOffsetValue;